import { NeoState } from '..';

export const selectCurrentImport = (state: NeoState) => state.imports.currentImport;

export const selectCurrentImportStatus = (state: NeoState) => state.imports.currentImport?.status;

export const selectImportUploading = (state: NeoState) => state.imports.isUploading;

export const selectImportList = (state: NeoState) => state.imports.importList;
